<script lang="ts">
  import { Translations } from '../translations';
  import { fade } from 'svelte/transition';

  export let translations: Translations;
  export let errors: any = {};
  export let invitationCode: string = "";
</script>

<div in:fade class="wk-grid">
  <wk-input label='{translations.get("Invitation Code")}' class="wk-column-6" type-class="wk-field-small">
    <input class="wk-field-input"
           autocomplete="one-time-code"
           spellcheck="false"
           required
           type="text"
           placeholder='{translations.get("Please enter your invitation code")}'
           name="InvitationCode" 
           bind:value={invitationCode}/>
    {#if errors.InvitationCode}<span class="wk-field-error field-validation-error">{errors.InvitationCode}</span>{/if}
  </wk-input>
</div>
